/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_UpdatedInputs */

const en_origin_updated = /** @type {(inputs: Origin_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin updated`)
};

const es_origin_updated = /** @type {(inputs: Origin_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origen actualizado`)
};

/**
* | output |
* | --- |
* | "Origin updated" |
*
* @param {Origin_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const origin_updated = /** @type {((inputs?: Origin_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_origin_updated(inputs)
	return es_origin_updated(inputs)
});